<template>
  <v-col cols="auto">
    <v-row>
      <v-col>
        <v-chip
          v-if="ongoingQuickInterviewExists"
          class="mr-2"
          color="red darken-2"
          dark
        >
          <v-avatar
            class="white"
            left
          >
            <v-icon class="red--text darken-2">
              mdi-exclamation
            </v-icon>
          </v-avatar>
          There is an Ongoing Quick Interview for this Party!
        </v-chip>
        <v-menu
          left
          offset-y
        >
          <template
            v-if="userCan.accessQuickInterviews"
            #activator="{ on: menu, attrs }"
          >
            <v-tooltip
              bottom
            >
              <template
                #activator="{ on: tooltip }"
              >
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...menu }"
                >
                  <v-icon>
                    mdi-account-voice
                  </v-icon>
                </v-btn>
              </template>
              <span>Quick Interviews</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item
              v-if="userCan.createQuickInterview"
              :disabled="ongoingQuickInterviewExists"
              @click="_ => openQuickInterviewWizard()"
            >
              <v-list-item-title>Start new Quick Interview</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="userCan.listQuickInterviews"
              @click="_ => openQuickInterviewsList()"
            >
              <v-list-item-title>Show previous Quick Interviews</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="currentUserCanResumeOngoingQuickInterview"
              @click="_ => openQuickInterviewWizard()"
            >
              <v-list-item-title>Resume Quick Interview</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <QuickInterviewsListDialog
      v-if="showQuickInterviewsList"
      v-model="showQuickInterviewsList"
    />
    <QuickInterviewWizard
      v-if="showQuickInterviewWizard"
      v-model="showQuickInterviewWizard"
      :interview-id="ongoingQuickInterviewId"
    />
    <NotificationDialog
      v-model="showOngoingQuickInterviewNotification"
      color="red darken-4"
      dark
      title="Ongoing Quick Interview warning"
    >
      <p>There is an Ongoing Quick Interview for this Party!</p>
      <p v-if="currentUserCanResumeOngoingQuickInterview">
        Because you were conducting the Interview, you may
        <a
          class="text-decoration-underline"
          @click="_ => openQuickInterviewWizard()"
        >
          resume it
        </a>.
      </p>
      <p v-else>
        Please do not edit any data until it is finished.
      </p>
    </NotificationDialog>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import actions from '@/data/Permissions/enums.json'
import { alertHandler } from '@/alertHandler'
import { parseErrorResponse } from '@/utilities/error-responses'

import { PARTY_NAMESPACE } from '@/store/party'
import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'
import { USER_NAMESPACE } from '@/store/user'

import NotificationDialog from '@/components/Dialogs/Common/NotificationDialog.vue'
import QuickInterviewWizard from '@/components/Party/QuickInterview/QuickInterviewWizard.vue'
import QuickInterviewsListDialog from '@/components/Party/QuickInterview/QuickInterviewsListDialog.vue'

export default {
  name: 'QuickInterviewButton',

  components: {
    NotificationDialog,
    QuickInterviewWizard,
    QuickInterviewsListDialog,
  },

  setup () {
    return {
      ...alertHandler(),
    }
  },

  data () {
    return {
      showOngoingQuickInterviewNotification: false,
      showQuickInterviewWizard: false,
      showQuickInterviewsList: false,
    }
  },

  computed: {
    currentUserCanResumeOngoingQuickInterview () {
      return this.userCan.createQuickInterview &&
        this.ongoingQuickInterviewExists &&
        this.ongoingQuickInterview.user_id === this.currentUser.id
    },

    ongoingQuickInterview () {
      return this.quickInterviewsList.
        reduce((res, qi) => {
          if (!['S', 'R'].includes(qi.status)) return res
          if (!res || qi.id > res.id) res = qi
          return res
        }, null)
    },

    ongoingQuickInterviewExists () {
      return !!this.ongoingQuickInterviewId
    },

    ongoingQuickInterviewId () {
      return this.ongoingQuickInterview?.id
    },

    userCan () {
      return {
        accessQuickInterviews: this.can(actions.Platform.Tools.QuickInterviews),
        createQuickInterview: this.can(actions.Platform.Tools.QuickInterviews),
        listQuickInterviews: this.can(actions.Platform.Tools.QuickInterviews),
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterviewsList',
    ]),

    ...mapGetters(USER_NAMESPACE, [
      'can',
      'currentUser',
    ]),
  },

  async mounted () {
    await this.listQuickInterviews({ party_id: this.peParty.id }).
      catch(e => this.displayAlert('error', parseErrorResponse(e)))

    if (this.ongoingQuickInterviewExists) this.showOngoingQuickInterviewNotification = true
  },

  methods: {
    openQuickInterviewWizard () {
      this.showOngoingQuickInterviewNotification = false
      this.showQuickInterviewWizard = true
    },

    openQuickInterviewsList () {
      this.showQuickInterviewsList = true
    },

    ...mapActions(QUICK_INTERVIEW_NAMESPACE, [
      'listQuickInterviews',
    ]),
  },
}
</script>
